import React from 'react';
import { Check } from 'lucide-react';
import { FORM_STEPS } from '../../constants/propertyConstants';

/**
 * FormStepIndicator Component
 * Displays progress through the multi-step form
 */
const FormStepIndicator = ({ currentStep, completedSteps }) => {
    return (
        <div className="mb-8">
            <div className="flex items-center justify-between">
                {FORM_STEPS.map((step, index) => {
                    const isActive = currentStep === step.id;
                    const isCompleted = completedSteps.includes(step.id);
                    const isLast = index === FORM_STEPS.length - 1;

                    return (
                        <React.Fragment key={step.id}>
                            <div className="flex flex-col items-center">
                                {/* Step Circle */}
                                <div
                                    className={`
                                        w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm
                                        transition-colors duration-200
                                        ${isCompleted
                                            ? 'bg-highland-500 text-white'
                                            : isActive
                                            ? 'bg-highland-500 text-white ring-4 ring-highland-100'
                                            : 'bg-soil-100 text-soil-600'
                                        }
                                    `}
                                >
                                    {isCompleted ? (
                                        <Check className="h-5 w-5" />
                                    ) : (
                                        step.id
                                    )}
                                </div>

                                {/* Step Label */}
                                <div className="mt-2 text-center hidden md:block">
                                    <p
                                        className={`
                                            text-xs font-medium
                                            ${isActive ? 'text-highland-500' : 'text-soil-600'}
                                        `}
                                    >
                                        {step.name}
                                    </p>
                                </div>
                            </div>

                            {/* Connector Line */}
                            {!isLast && (
                                <div
                                    className={`
                                        flex-1 h-0.5 mx-2 transition-colors duration-200
                                        ${isCompleted ? 'bg-highland-500' : 'bg-soil-100'}
                                    `}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>

            {/* Mobile Step Label */}
            <div className="mt-4 text-center md:hidden">
                <p className="text-sm font-medium text-soil-900">
                    Step {currentStep}: {FORM_STEPS.find(s => s.id === currentStep)?.name}
                </p>
                <p className="text-xs text-soil-400 mt-1">
                    {currentStep} of {FORM_STEPS.length}
                </p>
            </div>
        </div>
    );
};

export default FormStepIndicator;
